module.exports = __webpack_public_path__ + "img/hk-bg-light.edd96d5b.jpg";